import { render, staticRenderFns } from "./TabelaOsPedido.vue?vue&type=template&id=197beeab&scoped=true&"
import script from "./TabelaOsPedido.vue?vue&type=script&lang=js&"
export * from "./TabelaOsPedido.vue?vue&type=script&lang=js&"
import style0 from "./TabelaOsPedido.vue?vue&type=style&index=0&id=197beeab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197beeab",
  null
  
)

export default component.exports